module.exports = "/_next/static/media/b7a4a1852a011321f6c4d93b2870f7db.svg";